<ng-container ngForm="pollInputForm" class="padding-full-5">
	<div class="well webcast-poll" *ngIf="poll && !poll.readOnly">

		<vb-ui-form-group>

			<label #uiLabel class="control-label" for="ewPollsQuestions">{{ 'Event_PollQuestionLabel' | translate }}</label>

			<textarea uiControl class="form-control" [placeholder]="'Event_PollQuestionPlaceHolder' | translate" id="ewPollsQuestions" name="pollQuestion" #pollQuestion="ngModel" required [(ngModel)]="poll.question" (ngModelChange)="onQuestionChange()" trim="blur"></textarea>

			<div *ngIf="pollQuestion.invalid" role="alert" vbUiErrorMessage uiValidation>
				@if (pollQuestion.errors.required) {
					{{ 'ThisFieldIsRequired' | translate }}
				}
			</div>
		</vb-ui-form-group>

		<vb-ui-form-group *ngIf="poll.answers?.length">
			<label #uiLabel class="control-label">{{ 'Event_PollAnswersLabel' | translate }}</label>

			<div uiControl ngModelGroup="ansGroup" #ansGroup="ngModelGroup">
				<input *ngFor="let answer of poll.answers;let aindex = index" [required]="aindex === 0 && isFirstAnswerRequired()" type="input" [placeholder]="'Event_PollAnswerPlaceHolder' | translate : { '0': aindex + 1 }" class="form-control margin-bottom-10" [name]="'pAnswer' + aindex" [attr.aria-label]="'Event_PollAnswerPlaceHolder' | translate : { '0': aindex + 1 }" [(ngModel)]="answer.text" #pAnswer="ngModel"/>
			</div>
			<div *ngIf="ansGroup.invalid" role="alert" uiValidation vbUiErrorMessage>
				{{ 'Event_PollAnswersRequiredError' | translate }}
			</div>
		</vb-ui-form-group>

		<div class="text-center">
			<button [disabled]="poll.answers.length >= maxAnswerCount" type="button" class="btn-icon-left margin-bottom-10 margin-top-5" (click)="addAnswer()" vbBtnPrimary>
				<span class="glyphicons plus"></span>
				{{ 'Event_AddPollResponse' | translate }}
			</button>
			<p>{{ 'MaximumOf' | translate : { '0': maxAnswerCount } }}</p>
		</div>

		<div class="poll-footer">
			<label id="ewPollMultipleChoice" class="control-label me-2">{{ 'Event_MultipleChoice' | translate }}</label>
			<div vbUiRadioBtnGroup aria-labelledby="ewPollMultipleChoice" role="radiogroup">
				<button type="button" class="btn btn-sm btn-white" [(ngModel)]="poll.multipleChoice" name="multipleChoiceYes" [vbUiRadioBtn]="true" [notThemed]="true" [activeClass]="'active'">
					{{ 'Yes' | translate }}
				</button>
				<button type="button" class="btn btn-sm btn-white" [(ngModel)]="poll.multipleChoice" name="multipleChoiceNo" [vbUiRadioBtn]="false" [notThemed]="true" [activeClass]="'active'">
					{{ 'No' | translate }}
				</button>
			</div>
			<div class="float-right">
				<button type="button" class="btn-sm float-right" (click)="onRemovePoll.emit()" vbBtnWhite>
					{{ 'Event_DeletePoll' | translate }}
				</button>
			</div>
		</div>
	</div>

	<div class="well webcast-poll result-view" *ngIf="poll && poll.readOnly">
		<div class="scroll-container">
			<h4>{{ poll.question }}</h4>

			<div *ngFor="let answer of poll.answers" class="poll-responses">
				<p><strong>{{ answer.text }}</strong></p>
				<div class="vote-bar" [ngStyle]="{'width': 80 * answer.count / poll.totalResponses  + '%', 'margin-right':(answer.count > 0) ? '3px' : '0'}"></div><span>{{answer.count}}</span>
			</div>
		</div>
		<p class="poll-sub-footer">{{ 'Event_Responses' | translate }}: {{poll.totalResponses}}
			<span class="float-right">{{ 'Event_MultipleChoice' | translate }}
				<span>
					{{ (poll.multipleChoice ? 'Yes' : 'No') | translate }}
				</span>
			</span>
		</p>
		<div class="poll-footer">
			<div class="form-group group">
				<div class="float-right">
					<button type="button" class="btn-sm float-right" (click)="removePoll()" vbBtnWhite>
						{{ 'Event_DeletePoll' | translate }}
					</button>
				</div>
			</div>
		</div>
	</div>
</ng-container>
